import { Component, Inject, OnInit } from "@angular/core";
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Router } from "@angular/router";
import { CartService } from "src/app/components/shared/services/cart.service";
import { ProductService } from "src/app/components/shared/services/product.service";
import { Product } from "src/app/modals/product.model";
import { AlertServiceService } from "src/app/services/alerta.service";
import { ItemsService } from "src/app/services/items.service";
import { ProductDialogComponent } from "../../products/product-dialog/product-dialog.component";

@Component({
  selector: "app-filial-dialog",
  templateUrl: "./filial-dialog.component.html",
  styleUrls: ["./filial-dialog.component.sass"],
})
export class FilialDialogComponent implements OnInit {
  constructor(
    private router: Router,
    public productsService: ProductService,
    private cartService: CartService,
    public snackBar: MatSnackBar,
    private itemService: ItemsService,
    public dialogRef: MatDialogRef<ProductDialogComponent>,
    private alert: AlertServiceService,
    @Inject(MAT_DIALOG_DATA) public product: Product
  ) {}
  ngOnInit() {}

  public addToCart(product: Product, quantity) {
    ////console.log(product.NombreItm);
    if (quantity == 0) return false;
    if (product.SaldoG == 0) {
      this.snackBar.open(product.NombreItm + " no cuenta con stock", "×", {
        panelClass: "error",
        verticalPosition: "top",
        duration: 4000,
      });
      return false;
    }

    if (sessionStorage.getItem("tp") == null) {
      sessionStorage.setItem("tp", "TA");
      product.PVVenta = product.PV2;
    } else {
      if (sessionStorage.getItem("tp") == "TA") {
        product.PVVenta = product.PV2;
      } else {
        product.PVVenta = product.PV3;
      }
    }
    ////////console.log(_product);
    this.cartService.addToCart(product, parseInt(quantity));
    document.getElementById("carritoDialog").click();
    // this.alert.abrirCarrito()
  }

  public close(): void {
    // console.log('click')
    this.dialogRef.close();
  }
}
